import styled from 'styled-components';

// CONSTANTS
import { PORCELAIN, SANTAS_GRAY, WHITE } from '@/constants/colors';

// ASSETS
import contentBg from '@/assets/images/home/partner-home-content-bg.svg';

// UTILITY
import breakpoints from '@/utility/breakpoints';

export const Wrapper = styled.div`
  background-color: ${PORCELAIN};
  ${p => `min-height: calc(100vh - ${p.theme.headerHeight}px)`};

  .home-auth,
  &.home-auth {
    .content-hero__title {
      i {
        font-style: normal;
        font-size: 3.2rem;
      }
    }

    &__content {
      padding-top: 40px;
      padding-bottom: 56px;

      ${breakpoints.down('xs')} {
        padding-top: 10px;
        padding-bottom: 16px;
      }

      .page-content {
        > div:not(:last-of-type) {
          margin-bottom: 60px;

          ${breakpoints.down('xs')} {
            margin-bottom: 16px;
          }
        }
      }

      &--with-bg {
        position: relative;

        &:before {
          content: '';
          position: absolute;
          bottom: 100%;
          left: 0;
          height: 35px;
          width: 100%;
          background: url(${contentBg}) center center no-repeat;
          background-size: cover;
          z-index: 1;

          ${breakpoints.down('sm')} {
            height: 24px;
          }

          ${breakpoints.down('sm')} {
            height: 15px;
          }
        }
      }
    }

    &__search {
      .MuiFilledInput-root {
        background-color: ${WHITE};
      }

      .MuiFilledInput-root:hover,
      .MuiFilledInput-root.Mui-focused {
        background-color: ${WHITE};
      }

      .search {
        .MuiInputBase-root {
          border-radius: 8.5rem;
          padding: 10px 25px;
        }
      }

      .MuiInputAdornment-root,
      .MuiInputBase-input::-webkit-input-placeholder {
        color: ${SANTAS_GRAY};
      }

      &.autocomplete-opened {
        .MuiInputBase-root {
          border-radius: 2.5rem 2.5rem 0 0;
        }
      }
    }
  }

  .filters {
    .search {
      .MuiInputBase-root {
        font-size: 1.8rem;
        font-weight: 400;
        padding: 9px 15px;

        .MuiAutocomplete-input {
          padding: 5px 15px 5px 0;
        }
      }

      .MuiFilledInput-root:hover,
      .MuiFilledInput-root.Mui-focused {
        background-color: ${WHITE};
      }

      &__icon {
        color: inherit;
        font-size: 2rem;
        margin-top: 0;
        margin-right: 10px;
      }
    }
  }

  .content-hero {
    background-color: ${p => p.theme.palette.home.left};
    color: ${p => p.theme.palette.home.leftText};
  }
`;

export default Wrapper;
